import { ClaimStatus } from '@/src/app/Interfaces/Insurance/Claim';
import FormControlledDropdown from '../../../components/inputs/FormInputs/FormControlledDropdown';

export type ClaimFiltersOptions = {
  claimStatus: ClaimStatus | 'all';
};

export const CLAIM_STATUS = [
  { label: 'Active', value: ClaimStatus.Active },
  { label: 'Closed', value: ClaimStatus.Closed },
  { label: 'On Notice', value: ClaimStatus.OnNotice },
  { label: 'All', value: 'all' },
];

const ClaimFilters = () => {
  return (
    <div className="col">
      <FormControlledDropdown
        formID="claimStatus"
        defaultValue={ClaimStatus.Active}
        options={CLAIM_STATUS}
        labelField="label"
        valueField="value"
        placeholder="Select claim state"
        clearable={false}
      />
    </div>
  );
};

export default ClaimFilters;
